<template>
  <v-content>
    <ErrorSnackbar
      :show="getError.length > 0 ? true: false"
      @close="clearError">
      <template v-slot:text>
        <ul>
          <li
            v-for="e in getError"
            :key="e"> {{ e }} </li>
        </ul>
      </template>
    </ErrorSnackbar>
    <Wait :show='loading' :progressValue='progress'/>
    <div id="core-view">
      <v-fade-transition mode="out-in">
        <router-view />
      </v-fade-transition>
    </div>
    <core-footer v-if="$route.name !== 'Maps'" />
  </v-content>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import ErrorSnackbar from '../busie/ErrorSnackbar'
import Wait from '@/components/busie/Wait'

export default {
  metaInfo () {
    return {
      title: 'Range by Busie'
    }
  },
  components: {
    ErrorSnackbar,
    Wait
  },
  data: () => {
    return {
    }
  },
  computed: {
    querystring () {
      return `?trip__dispatch__id=${this.location}`
    },
    fetchQuotes () {
      return Date.now() - new Date(this.lastUpdated).getTime() > 60 * 1000
    },
    ...mapGetters('app', [ 'loading', 'progress', 'getError' ]),
    ...mapGetters('quotes', ['lastUpdated']),
    ...mapGetters('auth', [ 'isLoggedIn' ]),
    ...mapGetters('user', [ 'location' ])
  },
  mounted () {
    if (this.isLoggedIn && this.fetchQuotes) {
      this.fetchAll(this.querystring)
    }
  },
  methods: {
    ...mapActions('quotes', ['fetchAll']),
    ...mapActions('app', ['clearError', 'toggleLoading'])
  }
}
</script>

<style>
#core-view {
  padding-bottom: 100px;
}
</style>
